var React = require('react');

function UserCheckIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M11.6,2c2.2,0,4.1,1.8,4.1,4.1s-1.8,4.1-4.1,4.1S7.5,8.3,7.5,6.1S9.4,2,11.6,2z M10.7,17.3c0-2.1,1.1-3.9,2.8-4.9c-0.6-0.1-1.2-0.2-1.9-0.2c-4.6,0-8.4,3.8-8.5,6.2c0,2.3,3.5,2.5,7.9,2.5H12C11.2,19.9,10.7,18.7,10.7,17.3z","key":0}),React.createElement("circle",{"fill":"#52AF00","cx":"16.2","cy":"17.3","r":"4.7","key":1}),React.createElement("path",{"fill":"#FFFFFF","d":"M15.4,19c-0.1,0-0.2,0-0.3-0.1l-1.2-1.2c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l0,0l0.8,0.8l2.3-2.3c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-2.6,2.6C15.7,19,15.6,19,15.4,19z","key":2})]);
}

UserCheckIcon.defaultProps = {"data-dmid":"dm-user-check","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","pointerEvents":"none","color":"color2"};

module.exports = UserCheckIcon;

UserCheckIcon.default = UserCheckIcon;
